import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'External Resources' }]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">External Resources</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				New York Motor Vehicle Bureau
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						href="http://www.nydmv.state.ny.us/"
						rel="noopener noreferrer"
						target="_blank"
						className="text-blue-600 underline"
					>
						http://www.nydmv.state.ny.us/ (opens in a new tab)
					</a>
				</p>
				Insurance Institute for Highway Safety - 2010 Safest Vehicle List
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						href="http://www.iihs.org/ratings/"
						rel="noopener noreferrer"
						target="_blank"
						className="text-blue-600 underline"
					>
						http://www.iihs.org/ratings/ (opens in a new tab)
					</a>
				</p>
				Free Home Inventory Software
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						href="http://www.knowyourstuff.org/"
						rel="noopener noreferrer"
						target="_blank"
						className="text-blue-600 underline"
					>
						http://www.knowyourstuff.org/ (opens in a new tab)
					</a>
				</p>
				<a
					href="https://www.ssa.gov/OACT/quickcalc/index.html"
					rel="noopener noreferrer"
					target="_blank"
					className="text-blue-600 underline"
				>
					Social Security Income Estimator (opens in a new tab)
				</a>
				<br />
				<a
					href="http://bretwhissel.net/amortization/"
					rel="noopener noreferrer"
					target="_blank"
					className="text-blue-600 underline"
				>
					Loan Amortization Calculator (opens in a new tab)
				</a>
				<br />
				<a
					href="https://www.schwab.com/public/schwab/investing/retirement_and_planning/understanding_iras/ira_calculators/beneficiary_rmd"
					rel="noopener noreferrer"
					target="_blank"
					className="text-blue-600 underline"
				>
					Beneficiary RMD Calculator (opens in a new tab)
				</a>
				<br />
				<a
					href="http://www.unitedprofessionaladvisors.com/learning_center/research/"
					rel="noopener noreferrer"
					target="_blank"
					className="text-blue-600 underline"
				>
					UPA Planning Detailed Concepts (opens in a new tab)
				</a>
				<br />
				<a
					href="https://smartasset.com/taxes/new-york-tax-calculator#712ROcx7mj"
					rel="noopener noreferrer"
					target="_blank"
					className="text-blue-600 underline"
				>
					New York Tax Estimator (opens in a new tab)
				</a>
			</p>
		</main>
	)
}
